"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadFontsForStorybook = void 0;

var _global = require("../components/shared/global");
/* eslint-env browser */
// Load the font and avoid re-loading it when components change


var fontLinkId = 'storybook-font-link-tag';

var loadFontsForStorybook = function loadFontsForStorybook() {
  if (!document.getElementById(fontLinkId)) {
    var fontLink = document.createElement('link');
    fontLink.id = fontLinkId;
    fontLink.href = _global.fontUrl;
    fontLink.rel = 'stylesheet';
    document.head.appendChild(fontLink);
  }
};

exports.loadFontsForStorybook = loadFontsForStorybook;